import * as React from 'react'
import TourExternalLinkModel from '../../models/TourExternalLinkModel'
import { Buttons, Col, FieldFooter, FormFieldLabel, FormFieldWrapper, nameof, Row, TextFormField, Tooltip } from 'traveldesk-ui'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'traveldesk-ui/dist/store'
interface Props {
    links: TourExternalLinkModel[]
    onChange: (links: TourExternalLinkModel[]) => void
}
const TourFormExternalLinks = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)

    const onAdd = () => {
        props.onChange(props.links.concat([new TourExternalLinkModel()]))
    }
    const onChange = (guid: string, fieldName: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(props.links.map(x => x.guid == guid
            ? Object.assign(new TourExternalLinkModel(), x, { [fieldName]: e.target.value })
            : x
        ))
    }
    const onDelete = (guid: string) => {
        props.onChange(props.links.filter(x => x.guid != guid))
    }
    return <>
        <FormFieldWrapper>
            <hr />
            <FormFieldLabel label="Links to external resources" />
        </FormFieldWrapper>
        {props.links.map((link, index) => {
            return <React.Fragment>
                <Row>
                    <Col type="50">
                        <FormFieldWrapper customWrapperClass={!link.title ? "is-error" : ""}>
                            <label>Title</label>
                            <input type="text" value={link.title} onChange={onChange(link.guid, nameof<TourExternalLinkModel>("title"))} />
                            <FieldFooter error={!link.title ? "Link title is required" : undefined} />
                        </FormFieldWrapper>
                    </Col>
                    <Col type='50'>
                        <FormFieldWrapper customWrapperClass={!link.url ? "is-error" : ""}>
                            <i onClick={() => onDelete(link.guid)} className='fa fa-trash clickable float-right' />
                            <label>Url</label>
                            <input type="text" value={link.url} onChange={onChange(link.guid, nameof<TourExternalLinkModel>("url"))} />
                            <FieldFooter error={!link.url ? "Link Url is required" : undefined} />
                        </FormFieldWrapper>
                    </Col>
                </Row>
                <hr />
            </React.Fragment>
        })}
        <Tooltip text={Localization.getString('Add external resource link')}>
            <Buttons.ButtonSmallGreen onClick={onAdd}>
                <i className="fa fa-plus" />
            </Buttons.ButtonSmallGreen>
        </Tooltip>
    </>
}
export default TourFormExternalLinks